import { ComponentId } from "@omegagrid/core";
import { AppInfo, CreateComponentOptions } from "../types";
import { Container } from "./container";
import { AppComponent } from "../component";
import { PathSegments } from "@omegagrid/bucket";
import rp from "../global";

export class ApplicationCollection {

	readonly items: Map<string, Application> = new Map();

	constructor(readonly container: Container) { }

	get names() {
		return Array.from(this.items.keys());
	}

	clear() {
		this.items.clear();
	}

	register(app: Application) {
		this.items.set(app.name, app);
		app.register(this.container);
		return app;
	}

	unregister(name: string) {
		this.items.delete(name);
	}

	get<TApp extends Application = Application>(name: string) {
		return this.items.get(name) as TApp;
	}

	forEach(callback: (service: Application) => void) {
		this.items.forEach(callback);
	}

}

export abstract class Application {

	#container: Container;
	#info: AppInfo;

	_initialized = false;
	
	get container() { return this.#container }
	get info() { return this.#info }
	get name() { return this.#info.name }
	get host() { return this.#container.host }
	get router() { return this.#container.router }
	get initialized() { return this._initialized }
	
	constructor(info: AppInfo) {
		this.#info = info;
	}

	/**
	 * Executed after application is registered in the container
	 * @param container 
	 */
	async register(container: Container) {
		this.#container = container;
	}

	/**
	 * Executed before first use of the application
	 * @param container 
	 */
	async init(container: Container) {
		this.#container = container;
		this._initialized = true;
	}

	resolvePath(id: ComponentId): PathSegments|Promise<PathSegments> {
		return [];
	}

	openPath(path: string) { }

	abstract createComponent(id: ComponentId, options?: CreateComponentOptions): Promise<AppComponent>|AppComponent|null;

	/**
	 * Static synchronous accessor
	 * @returns Application
	 */
	static get<T extends Application = Application>() {
		return [...rp.applications.items.values()].find(a => a instanceof this) as T;
	}

}
